import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FeaturedReleases from "./sections/FeaturedReleases";
import AnalogPromise from "./sections/AnalogPromise";
import Newsletter from "./sections/Newsletter";
import Footer from "@/reusable_sections/Footer";
import PremiumArcadeHeroCarousel from "./sections/PremiumArcadeHeroCarousel";
export default function HomePage() {
  return <div>
      <Header />
      <PremiumArcadeHeroCarousel />
      <FeaturedReleases />
      <AnalogPromise />
      <Newsletter />
      <Footer />
    </div>;
}